import React, { Component } from 'react';
import ConditionalLoader from 'components/ConditionalLoader';
import { evaluateFeatureFlag, getDefaultValues } from 'components/FeatureFlagInit/helper';

class MaintenanceModeCheck extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialized: false,
      maintenanceModeFlag: null
    };
  }

  async componentDidMount() {
    const response = await fetch(
      'https://dndw32r4edmw5.cloudfront.net/assets/frontend-js/feature-flags/flags.json'
    );
    const data = await response.json();

    this.setState({
      initialized: true,
      maintenanceModeFlag: data['maintenance-mode-v2']
    });
  }

  componentDidUpdate() {
    this.checkFlagAndRedirect();
  }

  checkFlagAndRedirect = () => {
    const { maintenanceModeFlag } = this.state;
    const { companyId } = this.props;

    let maintenanceMode = false;
    let values = getDefaultValues();

    if (!values.length && companyId) {
      values = [companyId];
    }

    maintenanceMode = evaluateFeatureFlag({ featureFlag: maintenanceModeFlag, values });

    if (maintenanceMode) {
      window.location.href = '/#/maintenance';
    } else if (window.location.hash.indexOf('/maintenance') > -1) {
      window.location.href = '/#/learner';
      window.location.reload(true);
    }
  };

  render() {
    const { initialized } = this.state;
    const { children } = this.props;

    return (
      <ConditionalLoader loading={!initialized} fullScreen={true} mode="dark">
        {children}
      </ConditionalLoader>
    );
  }
}

export default MaintenanceModeCheck;
